import React from 'react'
import { Col, Row } from 'reactstrap'
type IProps ={
    liLabel :string ;
    overAllValue : number ;
    calculatePercentWith?: number;
    calculatePercentageWithAllClasses?: {overall:number; 10:number; 11:number; 12:number};
    className ? :string ;
    classWise? :boolean ;
    classData ? : {class10: number ,class11: number ,class12: number}
}
const TableRow = ({liLabel ,overAllValue, calculatePercentWith, calculatePercentageWithAllClasses, className ,classWise = false,classData}:IProps) => {

  const countPercentage = (value, totalValue) => {
    if (value && totalValue) {
      let percent = (Number(value) / Number(totalValue)) * 100
      return percent ? ` (${percent.toFixed(2)} %)` : `0.00 %`
    }
    else {
      return "0"
    }
  };

  return (
    <Row className={`mx-2 ${className}`}>
      { classWise ? <>
              <Col className={`border text-lg p-2 ${classWise ? `col-5` :``} `}>{liLabel}</Col>
              <Col className=' border text-center text-lg p-2'>{Math.round(classData?.class10)}{ calculatePercentageWithAllClasses ? countPercentage(classData?.class10,calculatePercentageWithAllClasses?.[10]) :""}</Col>
              <Col className=' border text-center text-lg p-2'>{Math.round(classData?.class11)}{ calculatePercentageWithAllClasses ? countPercentage(classData?.class11,calculatePercentageWithAllClasses?.[11]) :""}</Col>
              <Col className=' border text-center text-lg p-2'>{Math.round(classData?.class12)}{ calculatePercentageWithAllClasses ? countPercentage(classData?.class12,calculatePercentageWithAllClasses?.[12]) :""}</Col>
              <Col className=' border text-center text-lg p-2'>{Math.round(overAllValue)}{ calculatePercentageWithAllClasses ? countPercentage(overAllValue,calculatePercentageWithAllClasses?.overall) :""}</Col>
      </> : 
           <>
              <Col className=' border text-lg p-2'>{liLabel}</Col>
              <Col className=' border text-center text-lg p-2'>{Math.round(overAllValue)}{calculatePercentWith ? countPercentage(overAllValue,calculatePercentWith) :""}</Col>
           </>}
    </Row>
  )
}

export default TableRow
